import { CheckmarkCircleFilled, CircleFilled, CircleRegular } from '@fluentui/react-icons';
import { tokens } from '@fluentui/react-theme';

export interface IProgressIndicatorStepIconProps {
    isComplete: boolean;
    isCurrent: boolean;
}

export function ProgressIndicatorStepIcon(props: Readonly<IProgressIndicatorStepIconProps>) {
    const { isComplete, isCurrent } = props;

    if (isComplete) {
        return <CheckmarkCircleFilled fontSize={28} color={tokens.colorBrandForeground1} />;
    }

    return isCurrent 
        ? <CircleFilled fontSize={28} color={tokens.colorBrandForeground1} />
        : <CircleRegular fontSize={28} />;
}